import { Component, Input } from '@angular/core';

import { trackByValue } from '@recruitee/common';
import { TranslatePipe } from '@recruitee/i18n';
import { RtTooltip, IconComponent } from '@recruitee/user-interface';

import type { MissingFeature } from '../product-order-downgrade.types';

@Component({
  selector: 'rt-multilink-downgrade-item',
  templateUrl: './multilink-downgrade-item.component.html',
  styleUrls: ['./multilink-downgrade-item.component.less'],
  imports: [IconComponent, RtTooltip, TranslatePipe],
})
export class MultilinkDowngradeItemComponent {
  @Input() public missingFeature: MissingFeature;
  @Input() public trial: boolean;

  public trackByValue = trackByValue;
}
